export const TranscodingStatuses = {
  FAILED: 'FAILED',
  IN_QUEUE: 'IN-QUEUE',
  INPROGRESS: 'INPROGRESS',
  PREVIEW_READY: 'PREVIEW_READY',
  READY: 'READY'
};